// O dashboard de produtividade do agente e servido pela Reports (Mexx.Mexx2DO.Reports.Api), nao
// pelo 2DO: e um dashboard, e a Reports e o servico de relatorios -- o card de Reabertos ja
// vinha de la. As rotas tem o MESMO caminho de antes, so que neste host.
import Api from './apireport';


export const getSummary = async (startDate, endDate, organizationId, technicalTeamId, userId, originRequestId = 0) => {
  let data = [];
  await Api.get(`/dashboard/agentproductivity/summary?dateStart=${startDate}&dateEnd=${endDate}&organizationId=${organizationId}&technicalTeamId=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getByAgent = async (startDate, endDate, organizationId, technicalTeamId, userId, originRequestId = 0) => {
  let data = [];
  await Api.get(`/dashboard/agentproductivity/byagent?dateStart=${startDate}&dateEnd=${endDate}&organizationId=${organizationId}&technicalTeamId=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getByChannel = async (startDate, endDate, organizationId, technicalTeamId, userId, originRequestId = 0) => {
  let data = [];
  await Api.get(`/dashboard/agentproductivity/bychannel?dateStart=${startDate}&dateEnd=${endDate}&organizationId=${organizationId}&technicalTeamId=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getHourly = async (startDate, endDate, organizationId, technicalTeamId, userId, originRequestId = 0) => {
  let data = [];
  await Api.get(`/dashboard/agentproductivity/hourly?dateStart=${startDate}&dateEnd=${endDate}&organizationId=${organizationId}&technicalTeamId=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getFcr = async (startDate, endDate, organizationId, technicalTeamId, userId, originRequestId = 0) => {
  let data = [];
  await Api.get(`/dashboard/agentproductivity/fcr?dateStart=${startDate}&dateEnd=${endDate}&organizationId=${organizationId}&technicalTeamId=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getCsat = async (startDate, endDate, organizationId, technicalTeamId, userId, originRequestId = 0) => {
  let data = [];
  await Api.get(`/dashboard/agentproductivity/csat?dateStart=${startDate}&dateEnd=${endDate}&organizationId=${organizationId}&technicalTeamId=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getNps = async (startDate, endDate, organizationId, technicalTeamId, userId, originRequestId = 0) => {
  let data = [];
  await Api.get(`/dashboard/agentproductivity/nps?dateStart=${startDate}&dateEnd=${endDate}&organizationId=${organizationId}&technicalTeamId=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getSla = async (startDate, endDate, organizationId, technicalTeamId, userId, originRequestId = 0) => {
  let data = [];
  await Api.get(`/dashboard/agentproductivity/sla?dateStart=${startDate}&dateEnd=${endDate}&organizationId=${organizationId}&technicalTeamId=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

// Vieram de /calledStatus/dashboard/{attendancetime,solutiontime} no 2DO, que continua servindo
// aquelas rotas para a tela de Produtividade antiga. Aqui as datas vao em yyyy-MM-dd, igual aos
// demais endpoints deste dashboard -- na Reports elas passam pela mesma validacao de periodo.
export const getAttendanceTime = async (startDate, endDate, organizationId, technicalTeamId, userId, originRequestId = 0) => {
  let data = [];
  await Api.get(`/dashboard/agentproductivity/attendancetime?dateStart=${startDate}&dateEnd=${endDate}&organizationId=${organizationId}&technicalTeamId=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getSolutionTime = async (startDate, endDate, organizationId, technicalTeamId, userId, originRequestId = 0) => {
  let data = [];
  await Api.get(`/dashboard/agentproductivity/solutiontime?dateStart=${startDate}&dateEnd=${endDate}&organizationId=${organizationId}&technicalTeamId=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};
